import React from 'react';
import logo from '../../../assets/images/sd_one_blau.svg';
import './CompanyLogo.style.scss';

const CompanyLogo = () => <img className="CompanyLogo" src={logo} alt="Styria digital" />;

export default CompanyLogo;
